/** @internal */
export const MULTI_VENDOR_LOADED = 'MULTI_VENDOR_LOADED';

/** @internal */
export const initialState = {
	vendors: null,
	isFetching: true,
};

export default function reducer(state = initialState, action) {
	switch (action.type) {
		case MULTI_VENDOR_LOADED:
			return {
				...state,
				vendors: action.payload,
				isFetching: false,
			};
		default:
			return state;
	}
}
